jQuery(document).ready(function ($) {

  // EVENTS TAB LOGIC
  $('#events-tab').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('active');
    $('#calendar-tab').removeClass('active');

    $('.events-container').addClass('active');
    $('.calendar-container').removeClass('active');
  });

  $('#calendar-tab').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('active');
    $('#events-tab').removeClass('active');

    $('.calendar-container').addClass('active');
    $('.events-container').removeClass('active');
  });


  // SOCIAL WIDGET TABS
  $('.social-widget-wrapper .tab').on('click', function () {
    // Remove active class from all tabs and views
    $('.social-widget-wrapper .tab').removeClass('active');
    $('.social-widget-wrapper .view').removeClass('active');

    // Add active class to clicked tab
    $(this).addClass('active');

    // Show corresponding view
    const viewId = $(this).attr('id').replace('-tab', '-view');
    $('#' + viewId).addClass('active');
  });


  // TOGGLE SEARCH
  $('#search-icon').on('click', function () {
    $('#search-form-wrap').toggleClass('active');
  });


  // Tab Navigation Support
  // Target all menu items that have children
  $('.menu-item-has-children > a').on('keydown', function (e) {
    // Check if Enter or Space key was pressed
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();

      const $parentLi = $(this).parent();
      const $subMenu = $parentLi.find('.sub-menu').first();

      if ($subMenu.length) {
        // Toggle submenu visibility
        if ($subMenu.css('opacity') !== '1') {
          // Show submenu
          $subMenu.css({
            'opacity': '1',
            'pointer-events': 'all'
          });

          // Set aria-expanded state
          $(this).attr('aria-expanded', 'true');

          // Focus first item in submenu
          const $firstSubMenuItem = $subMenu.find('a').first();
          if ($firstSubMenuItem.length) {
            $firstSubMenuItem.focus();
          }
        } else {
          // Hide submenu
          $subMenu.css({
            'opacity': '0',
            'pointer-events': 'none'
          });

          // Update aria-expanded state
          $(this).attr('aria-expanded', 'false');
        }
      }
    }
  });

  // Also add aria-expanded attribute initially to all parent menu items
  $('.menu-item-has-children > a').attr('aria-expanded', 'false');

  // Add support for Escape key to close submenus when focused within them
  $('.sub-menu a').on('keydown', function (e) {
    if (e.which === 27) { // Escape key
      const $subMenu = $(this).closest('.sub-menu');
      const $parentMenuItem = $subMenu.parent().find('> a');

      // Hide the submenu
      $subMenu.css({
        'opacity': '0',
        'pointer-events': 'none'
      });

      // Return focus to parent menu item
      $parentMenuItem.attr('aria-expanded', 'false').focus();

      e.preventDefault();
    }
  });


  // MOBILE MENU

  const $menuIcon = $('.mobile-menu-icon');
  const $navMain = $('.nav-main');

  $menuIcon.on('click', function () {
    $(this).toggleClass('active');
    $navMain.toggleClass('active');
  });


  // Handle submenu toggles (already matching your breakpoint)
  function initMobileMenuSubmenus() {
    const mobileBreakpoint = 991;
    if (window.innerWidth <= mobileBreakpoint) {
      let submenuCounter = 0;

      $('.menu-item-has-children > a').each(function () {
        const $link = $(this);
        const $parent = $link.parent();
        const $submenu = $parent.children('.sub-menu');

        if ($parent.find('.submenu-toggle').length === 0 && $submenu.length > 0) {
          submenuCounter++;
          const submenuId = `submenu-${submenuCounter}`;
          $submenu.attr('id', submenuId);

          const $toggle = $(`
            <button class="submenu-toggle" aria-controls="${submenuId}" aria-expanded="false">
              <span class="sr-only">Toggle submenu</span>
              <i class="fas fa-chevron-right"></i>
            </button>
          `);


          $link.after($toggle);

          $toggle.on('click', function (e) {
            e.preventDefault();
            const isOpen = $parent.hasClass('open');
            const $submenu = $parent.children('.sub-menu');

            if (!isOpen) {
              $parent.addClass('open');
              $submenu
                .css({ display: 'flex', opacity: 0 })
                .hide()
                .slideDown(200)
                .animate({ opacity: 1 }, { queue: false, duration: 200 });
              $(this).attr('aria-expanded', true);
            } else {
              $submenu.hide(); // Instantly hide with no animation
              $parent.removeClass('open');
              $(this).attr('aria-expanded', false);
            }
          });

        }
      });
    }
  }

  initMobileMenuSubmenus();

  // Re-init on resize
  $(window).on('resize', function () {
    $('.submenu-toggle').remove();
    $('.menu-item-has-children > .sub-menu').removeAttr('id');
    $('.menu-item-has-children').removeClass('open');
    initMobileMenuSubmenus();
  });

}); 